import moment from 'moment-timezone';

export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return '-';
  }

  // Use a regular expression to capture the different parts of the phone number
  const regex = /^(\d{3})(\d{3})(\d{4})$/;

  // Replace the matched pattern with the desired format
  const formattedNumber = phoneNumber.replace(regex, '($1) $2-$3');

  return formattedNumber;
};

export const convertTimestamps = (data: Record<string, any>) => {
  // Right now we get timestamps having been convered to UTC. We don't want timezones
  // so we need to convert them back to the local timezone and then strip the timezone info.
  const keys = Object.keys(data);
  const timezone = moment.tz.guess();

  keys.forEach((key) => {
    // Skip if the value is null, undefined, or not a string/number
    if (data[key] == null) return;

    // Convert to string to safely use indexOf
    const valueStr = String(data[key]);
    const parsed = moment(data[key], moment.ISO_8601, true);

    // Right now, we only want to convert timestamps (not dates) and the
    // best way I can figure out to determine if a value is a timestamp is to:
    // 1. See if the value parses
    // 2. See if the value contains a "T" (timestamps always contain a "T")
    if (parsed.isValid() && valueStr.indexOf('T') > -1) {
      data[key] = parsed.tz(timezone).format('YYYY-MM-DDTHH:mm:ss.SSS');
    }
  });
  return data;
};
